import React from 'react'
import Footer from '../Footer'
import Header from '../Header'
import ShoppingCartArea from '../ShoppingCartArea'

function ShoppingCart() {
    return (
        <div>
            <Header/>
            <ShoppingCartArea/>
            <Footer/>
        </div>
    )
}

export default ShoppingCart;